import { Link as RouterLink, type LinkProps } from 'react-router-dom'
import { useLocale } from './LocaleProvider'
import { localizedPath } from './paths'

export function Link({ to, ...props }: LinkProps) {
  const { locale } = useLocale()
  const target = typeof to === 'string' ? localizedPath(to, locale) : { ...to, pathname: to.pathname ? localizedPath(to.pathname, locale) : undefined }
  return <RouterLink {...props} to={target} />
}
